export default {
  metrics: '/portal/metrics',
}
